import React, { Component } from 'react';

import { isAposFimInscricaoFimPagamento } from '../../helper/ContextHelper';

import Grid from '@material-ui/core/Grid';

import Table, { DataTableLineTotals as Totals } from '../../components/Table/Table';
import {
    PAGE,
    TOTAL_ELEMENTS,
    TOTAL_PAGES,
} from '../../components/Table/Utils';

import { numberFormat } from '../../helper/MaskHelper';

import {
    ButtonNewTabCandidatosPorMunicipio,
    ButtonNewTabCandidatosPorMunicipioAndStatus,
    ButtonNewTabCandidatosPorMunicipioAndDepAdmin,
    ButtonNewTabCandidatosPorStatus,
    ButtonNewTabCandidatosPorDepAdmin,
    ButtonNewTabCandidatos,
} from '../Buttons/ButtonsNewTab';

export class DadosMunicipios extends Component {
    constructor (props) {
        super(props)
        this.state = {
            page: PAGE,
            size: 50,
            totalElements: TOTAL_ELEMENTS,
            totalPages: TOTAL_PAGES,
        }
    }

    sumMunicipios = () => this.props.municipios.length;
    sumCandidatos = () => this.props.municipios.reduce((total, mun) => total + mun.candidatos, 0);
    sumCandidatosInscritos = () => this.props.municipios.reduce((total, mun) => total + mun.candidatosInscritos, 0);
    sumCandidatosAguardandoPagamento = () => this.props.municipios.reduce((total, mun) => total + mun.candidatosAguardandoPagamento, 0);
    sumCandidatosComPendencias = () => this.props.municipios.reduce((total, mun) => total + mun.candidatosComPendencias, 0);
    sumCandidatosNaoFinalizados = () => this.props.municipios.reduce((total, mun) => total + mun.candidatosNaoFinalizados, 0);
    sumEscolasPublicas = () => this.props.municipios.reduce((total, mun) => total + mun.escolasPublicas, 0);
    sumEscolasPrivadas = () => this.props.municipios.reduce((total, mun) => total + mun.escolasPrivadas, 0);

    handlePage = (value) => this.setState({ ...this.state, page: value, });
    handleRowsPerPage = (value) => this.setState({ ...this.state, size: value, page: 0, });
    handleTotalPages = () => Math.ceil(this.props.municipios.length / this.state.size);
    handleTotalElements = () => this.props.municipios.length;

    getUf = codigoMunicipio => this.props.municipios.slice(this.state.page * this.state.size, (this.state.page * this.state.size) + this.state.size).find(mun => mun.codigoMunicipio === codigoMunicipio).uf;

    newTabCandidatosPorMunicipio = (qtd, codigoMunicipio, query = "") => {
        if (!codigoMunicipio)
            return <ButtonNewTabCandidatos qtd={numberFormat(qtd)} query="&comLocalProvaSelecionado=false" />;

        return <ButtonNewTabCandidatosPorMunicipio qtd={numberFormat(qtd)} uf={this.getUf(codigoMunicipio)} municipio={codigoMunicipio} query={query} />
    }

    newTabCandidatosPorMunicipioAndStatus = (qtd, codigoMunicipio, status, query = "") => {
        if (!codigoMunicipio)
            return <ButtonNewTabCandidatosPorStatus qtd={numberFormat(qtd)} status={status} query={query} />

        return <ButtonNewTabCandidatosPorMunicipioAndStatus qtd={numberFormat(qtd)} uf={this.getUf(codigoMunicipio)} municipio={codigoMunicipio} status={status} query={query} />
    }

    newTabCandidatosPorMunicipioAndDepAdmin = (qtd, codigoMunicipio, depAdmin, query = "") => {
        if (!codigoMunicipio)
            return <ButtonNewTabCandidatosPorDepAdmin qtd={numberFormat(qtd)} depAdmin={depAdmin} query="&comLocalProvaSelecionado=false" />

        return <ButtonNewTabCandidatosPorMunicipioAndDepAdmin qtd={numberFormat(qtd)} uf={this.getUf(codigoMunicipio)} municipio={codigoMunicipio} depAdmin={depAdmin} query={query} />
    }

    render () {
        const columns = [
            { label: '#', name: 'codigoMunicipio', func: null, key: true, hidden: true, },
            { label: 'Municipio', name: 'municipio', func: (value, codigoMunicipio) => value ? `${value} / ${this.getUf(codigoMunicipio)}` : "Sem Municipio Informado", key: false, width: '23', orderLabel: 'asc', },
            { label: 'Candidatos', name: 'candidatos', func: this.newTabCandidatosPorMunicipio, key: false, width: '11', },            
			{ label: 'Inscrições Finalizadas', name: 'candidatosInscritos', func: (qtd, codigoMunicipio) =>  this.newTabCandidatosPorMunicipioAndStatus(qtd, codigoMunicipio, "FINALIZADO"), key: false, width: '11', },
            { label: 'Inscrições Aguardando Pagamento', name: 'candidatosAguardandoPagamento', func: (qtd, codigoMunicipio) => this.newTabCandidatosPorMunicipioAndStatus(qtd, codigoMunicipio, "AGUARDANDO_PAGAMENTO"), key: false, width: '11', hidden: isAposFimInscricaoFimPagamento(this.props.contexts), },
            { label: 'Inscrições Com Pendências', name: 'candidatosComPendencias', func: (qtd, codigoMunicipio) => this.newTabCandidatosPorMunicipioAndStatus(qtd, codigoMunicipio, "INICIADO"), key: false, width: '11', hidden: isAposFimInscricaoFimPagamento(this.props.contexts), },
            { label: 'Inscrições Não Finalizadas', name: 'candidatosNaoFinalizados', func: (qtd, codigoMunicipio) => this.newTabCandidatosPorMunicipioAndStatus(qtd, codigoMunicipio, "INCOMPLETO", "&comEscolaSelecionada=true&comLocalProvaSelecionado=true"), key: false, width: '11', hidden: isAposFimInscricaoFimPagamento(this.props.contexts), },
            { label: 'Total de Escolas Públicas', name: 'escolasPublicas', func: (qtd, codigoMunicipio) => this.newTabCandidatosPorMunicipioAndDepAdmin(qtd, codigoMunicipio, "PUBLICA"), key: false, width: '11' },
            { label: 'Total de Escolas Privadas', name: 'escolasPrivadas', func: (qtd, codigoMunicipio) => this.newTabCandidatosPorMunicipioAndDepAdmin(qtd, codigoMunicipio, "PRIVADA"), key: false, width: '11' },
        ];
        
        const actions = [];
        
        const totals = [
            { column: 0, label: 'Municípios', value: numberFormat(this.sumMunicipios()), width: '23', },
            { column: 1, label: 'Candidatos', value: numberFormat(this.sumCandidatos()), width: '11', },            
            { column: 2, label: 'Inscrições Finalizadas', value: numberFormat(this.sumCandidatosInscritos()), width: '11', },
            { column: 3, label: 'Inscrições Aguardando Pagamento', value: numberFormat(this.sumCandidatosAguardandoPagamento()), width: '11', hidden: isAposFimInscricaoFimPagamento(this.props.contexts), },            
            { column: 4, label: 'Inscrições Com Pendências', value: numberFormat(this.sumCandidatosComPendencias()), width: '11', hidden: isAposFimInscricaoFimPagamento(this.props.contexts), },
            { column: 5, label: 'Inscrições Não Finalizadas', value: numberFormat(this.sumCandidatosNaoFinalizados()), width: '11', hidden: isAposFimInscricaoFimPagamento(this.props.contexts), },
            { column: 6, label: 'Total de Escolas Públicas', value: numberFormat(this.sumEscolasPublicas()), width: '11', },
            { column: 7, label: 'Total de Escolas Privadas', value: numberFormat(this.sumEscolasPrivadas()), width: '11', },
        ];
        
        return (
            <Grid container spacing={3} style={{ marginTop: this.props.marginTop ?? 8 }}>
                <Grid item xs={12}>
                    <Table              
                        columns={columns}
                        tableData={this.props.municipios.slice(this.state.page * this.state.size, (this.state.page * this.state.size) + this.state.size)}
                        actions={actions}
                        page={this.state.page}
                        handlePage={this.handlePage}
                        handleTotalPages={this.handleTotalPages}
                        handleTotalElements={this.handleTotalElements}
                        rowsPerPage={this.state.size}
                        handleRowsPerPage={this.handleRowsPerPage}
                        sort={null}
                        fixedHeader={true}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Totals lineData={totals} columns={columns} showHead={true} />
                </Grid>
            </Grid>
        )
    }
}

export default DadosMunicipios;